import React, { useEffect, useRef, useState } from "react";
import train from "../../assets/Train.webp"; // also convert to WEBP
import "../../styles/Train.css";

const Train = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.2 },
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="train-section">
      <img
        src={train}
        alt=""
        className={`train ${visible ? "run" : ""}`}
        loading="lazy"
        decoding="async"
      />
    </section>
  );
};

export default Train;
